export const INSTANT_FEEDBACK_TYPES = {
    SUBMISSION: 'sub',
    PRESUBMISSION: 'pre',
    LTI: 'res',
    ACCESS_CODE: 'acc',
}
